import { api } from '../initFetch'

export const getOneDriveInfo = async (Token, TenantId) => {
  const res = await api.post('/p4m/OneDrive/GetOneDriveInfo', {
    Token,
    TenantId,
  })
  return res.json
}
